var map = {
	"./AmericanExpress.png": "2C04",
	"./Diners.png": "h+E6",
	"./Discover.png": "nU6U",
	"./Jcb.png": "44Cd",
	"./MasterCard.png": "INnX",
	"./UnionPay.png": "tP/l",
	"./Visa.png": "5+Ad",
	"./amazon.png": "Fk1p",
	"./amex-logo-xs.png": "QIBi",
	"./carte-bleu-logo-xs.png": "N7vV",
	"./cirrus.png": "APNm",
	"./comodo_secure.png": "Pjea",
	"./diners-logo-xs.png": "YH87",
	"./direct-debit.png": "msZC",
	"./discover-logo-xs.png": "3duY",
	"./ebay.png": "f+IJ",
	"./jcb-logo-xs.png": "/NKd",
	"./maestro.png": "iP2w",
	"./mastercard-logo-xs.png": "YZEw",
	"./paypal.png": "Xdbd",
	"./pci.png": "BST9",
	"./solo.png": "JnCe",
	"./switch.png": "iTLB",
	"./visa-electron.png": "I8NI",
	"./visa-logo-xs.png": "YMbF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DQWs";